


























import Vue from 'vue'
import { getPatientName, hasUnaddressedLiveAlert } from '@/utils/patients'
import { ALL_PATIENT_EVENT_VMS } from '@/view-model/patient-event-constants/MemberPatientEvents'
import { readableTimeSince } from '@/utils/time'
import { getPatientEventLastAddressedKey } from '@/jsonapi/PatientWithEvents'

export default Vue.extend({
  filters: {
    getPatientName,
  },
  props: {
    patient: {
      type: Object,
      default: null,
    },
    liveEvent: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      addressedCache: false,
    }
  },
  computed: {
    alertDescription() {
      return (
        this.liveEvent &&
        ALL_PATIENT_EVENT_VMS[this.liveEvent.eventName] +
          (this.liveEvent.eventType == 'consolidated' ? ' detected' : '')
      )
    },
    alertRelativeTime() {
      return this.liveEvent && readableTimeSince({ timestamp: this.liveEvent.eventTimestamp })
    },
    isVeryCritical() {
      return this.liveEvent && this.liveEvent.eventSeverity >= 4
    },
    eventKey() {
      return this.liveEvent && getPatientEventLastAddressedKey(this.patient.id, this.liveEvent)
    },
    loadIsAddressed(): boolean {
      return !hasUnaddressedLiveAlert(this.patient.id, this.liveEvent)
    },
    isAddressed(): boolean {
      return this.addressedCache || this.loadIsAddressed
    },
    isLive(): boolean {
      return this.liveEvent && this.liveEvent.eventType == 'live' // should always be true
    },
  },
  methods: {
    addressAlert(e) {
      e.preventDefault()
      this.addressedCache = true
      localStorage.setItem(this.eventKey, this.liveEvent.eventTimestamp)
      this.$emit('addressed')
    },
  },
})
